import React from 'react';
import { Database, CheckCircle, Settings, Play, Trash2 } from 'lucide-react';
import Button from '../../../components/ui/Button';

const ERPSystemCard = ({ system, integration, onConfigure, onTest, onDelete, testing }) => {
  const isConfigured = !!integration;
  const isActive = integration?.status === 'active';

  return (
    <div className="bg-white rounded-lg shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
      <div className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
              <Database className="w-6 h-6 text-blue-600" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">{system?.name}</h3>
              {isConfigured && (
                <span
                  className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium mt-1 ${
                    isActive ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                  }`}
                >
                  <CheckCircle className="w-3 h-3" />
                  {isActive ? 'Active' : 'Inactive'}
                </span>
              )}
            </div>
          </div>
        </div>

        <p className="text-sm text-gray-600 mb-4 line-clamp-2">{system?.description}</p>

        <div className="space-y-2 mb-4">
          <div>
            <p className="text-xs font-medium text-gray-700 mb-1">Supported Modules:</p>
            <div className="flex flex-wrap gap-1">
              {system?.supportedModules?.map((module) => (
                <span
                  key={module}
                  className="px-2 py-0.5 bg-blue-50 text-blue-700 text-xs rounded"
                >
                  {module}
                </span>
              ))}
            </div>
          </div>

          <div>
            <p className="text-xs font-medium text-gray-700 mb-1">Export Formats:</p>
            <div className="flex flex-wrap gap-1">
              {system?.exportFormats?.map((format) => (
                <span
                  key={format}
                  className="px-2 py-0.5 bg-gray-100 text-gray-700 text-xs rounded"
                >
                  {format}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="flex gap-2">
          {isConfigured ? (
            <>
              <Button
                onClick={onConfigure}
                variant="outline"
                size="sm"
                className="flex-1"
              >
                <Settings className="w-4 h-4 mr-1" />
                Configure
              </Button>
              <Button
                onClick={onTest}
                variant="outline"
                size="sm"
                disabled={testing}
              >
                {testing ? (
                  <span className="animate-spin">⟳</span>
                ) : (
                  <Play className="w-4 h-4" />
                )}
              </Button>
              <Button
                onClick={onDelete}
                variant="outline"
                size="sm"
                className="text-red-600 hover:bg-red-50"
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <Button
              onClick={onConfigure}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white"
              size="sm"
            >
              <Settings className="w-4 h-4 mr-2" />
              Setup Integration
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ERPSystemCard;